import { XCloseIcon } from '@/components/ui/icons'
import { cn } from '@/helpers/utils'

interface CtaBadgeProps {
	label: string
	/** Omit to render a plain, non-removable pill. */
	onRemove?: () => void
	removeLabel?: string
	className?: string
}

/** A pitched CTA as a rounded pill, optionally removable. Shared by the
 * attendee detail page and the mobile assign drawer so a selection reads
 * identically in both places. */
export function CtaBadge({
	label,
	onRemove,
	removeLabel,
	className
}: CtaBadgeProps) {
	return (
		<span
			className={cn(
				'inline-flex items-center gap-2 rounded-full border-[1.5px] border-neutral-900 px-3 py-1.5 font-medium text-neutral-900 text-xs',
				className
			)}
		>
			{label}
			{onRemove && (
				<button
					aria-label={removeLabel}
					className='text-neutral-500 hover:text-neutral-900'
					onClick={onRemove}
					type='button'
				>
					<XCloseIcon className='size-3.5' />
				</button>
			)}
		</span>
	)
}
